export default __webpack_public_path__ + "media/samples/test-video-poster-cf4d1d8e.png";